import AcceptedTable from './AcceptedTable';
import IncomeTable from './IncomeTable';
import FinancialBurdenTable from './FinancialBurdenTable';
import AnimalProductionTable from './AnimalProductionTable';
import CropProductionTable from './CropProductionTable';
import TerytTable from './TerytTable';
import TabPanelTable from './TabPanelTable';

export {
  AcceptedTable,
  IncomeTable,
  FinancialBurdenTable,
  AnimalProductionTable,
  CropProductionTable,
  TerytTable,
  TabPanelTable,
};
